import React, { useState } from "react";
import { MdClose, MdSend, MdDone } from "react-icons/md";
import styles from "./Franchise.module.css";
import { NavLink } from "react-router-dom";

export default function Franchise() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [message, setMessage] = useState("");
  const basePath = process.env.REACT_APP_BASE_PATH;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setIsModalOpen(false);
      // reset
      setName("");
      setPhone("");
      setCity("");
      setMessage("");
    }, 2000);
  };

  return (
    <section className={styles.franchiseSection}>
      <div className={styles.container}>
        {/* Left Side: Image illustration */}
        <div className={styles.imageColumn}>
          <img
            alt="Franchise Illustration"
            className={styles.franchiseImg}
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuCqMG-uFJWwYW4Ypux9N7FkWw3buVu3zTjzigQD4HY_PngBVvxsHBf1AO4Qcqc0LuoSp4ORe9a0HOwPWvDYEVW9sKX9dtUg_xGKv4f9oY47M_Ev3OoyqKw1B6jhjIcdmNq0kow9g-g3YHbcuKpWljeswOjL8vkOApAV92IA9caUoAKYtZCTdClF7q64E5ShVTMxOccqrSOMID83L-wLU67PwRkjhv0BJucrEeszF3vyb5nITW4cEKL00oMn9BvGvc6oO8ZneTgXNA"
            referrerPolicy="no-referrer"
          />
        </div>

        {/* Right Side: Text info */}
        <div className={styles.infoColumn}>
          <h2 className={styles.headline}>Become a franchise</h2>
          <p className={styles.description}>
            Explore a partnership with MechMiles as a franchisee and join us in
            serving together. Your complete engagement is highly valued.
          </p>
          {/* <button 
            onClick={() => setIsModalOpen(true)}
            className={styles.contactBtn}
          >
            Contact Us
          </button> */}
          <NavLink
            to={`${basePath}contact-us`}
            className={styles.contactBtnWrapper}
          >
            <button className={styles.contactBtn}>Contact Us</button>
          </NavLink>
        </div>
      </div>

      {/* Franchise Modal */}
      {isModalOpen && (
        <div className={styles.modalBackdrop}>
          <div className={styles.modalContent}>
            <button
              className={styles.closeBtn}
              onClick={() => setIsModalOpen(false)}
              aria-label="Close modal"
            >
              <MdClose size={24} />
            </button>

            {isSubmitted ? (
              <div className={styles.successWrapper}>
                <div className={styles.successIconCircle}>
                  <span className={styles.successIcon}>
                    <MdDone size={48} />
                  </span>
                </div>
                <h3 className={styles.successHeadline}>Application Sent!</h3>
                <p className={styles.successSub}>
                  Thank you. Our partnership team will contact you within 24
                  hours.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className={styles.form}>
                <h3 className={styles.formTitle}>Franchise Application</h3>
                <p className={styles.formSubtitle}>
                  Join the leading industrial automotive distribution network.
                </p>

                <div className={styles.field}>
                  <label className={styles.label}>FULL NAME</label>
                  <input
                    type="text"
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className={styles.input}
                    placeholder="Enter your name"
                  />
                </div>

                <div className={styles.field}>
                  <label className={styles.label}>PHONE NUMBER</label>
                  <input
                    type="tel"
                    required
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className={styles.input}
                    placeholder="Enter phone number"
                  />
                </div>

                <div className={styles.field}>
                  <label className={styles.label}>CITY / LOCATION</label>
                  <input
                    type="text"
                    required
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    className={styles.input}
                    placeholder="e.g., Mumbai, Pune, Delhi"
                  />
                </div>

                <div className={styles.field}>
                  <label className={styles.label}>
                    BRIEF MESSAGE (OPTIONAL)
                  </label>
                  <textarea
                    rows={3}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className={styles.textarea}
                    placeholder="Tell us about your dealership/business experience"
                  />
                </div>

                <button type="submit" className={styles.submitBtn}>
                  Submit Application{" "}
                  <span className={styles.sendIcon}>
                    <MdSend />
                  </span>
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
